/*******************************************************************************
 * $Id: orgSelectDialog.js 15652 2017-07-05 19:42:07Z dherold $
 *******************************************************************************/
import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';
import orgSelectDialogTemplate from './OrgSelectDialog.template.html';

export default angular
  .module('csm.ui.orgSelectDialog', [uiBootstrap])

  /*****************************************************************************
   * Service: OrgSelectDialog
   *
   * Provide selection from multiple organizations. This allows for navigation
   * of the organization list using the up and down arrow keys. This is meant to
   * work with OrgAccessItem objects.
   *
   * Note: The document will not receive key down events when this dialog is
   *       displayed.
   *****************************************************************************/
  /* @ngInject */
  .service('OrgSelectDialog', function ($uibModal) {
    /***************************************************************************
     * getProps */
    /**
     * Returns a control object for the model dialog that passes the orgList to
     * modal controller.
     *
     * @param  orgList List of OrganizationListItems to choose from
     * @return         Control object
     ***************************************************************************/
    var getProps = function (orgList) {
      return {
        template: orgSelectDialogTemplate,
        windowClass: 'org-select-popup',
        size: 'sm',
        backdrop: 'static',
        resolve: {
          orgs: function () {
            return orgList;
          }
        },
        controller: OrgSelectController
      };
    };

    /***************************************************************************
     * Controller: OrgSelectController */
    /**
     * Process the organizations available and provide selection management with
     * the arrow keys.
     *
     * @param orgs  array holding a list of org objects
     ***************************************************************************/
    /* @ngInject */
    function OrgSelectController(
      $scope,
      $uibModalInstance,
      $window,
      $document,
      orgs
    ) {
      /** Current selected index. */ var mIndex = -1;
      /** Organization List. */ $scope.orgList = orgs;

      /** Utility Functions. */
      $scope.isSelected = function (idx) {
        return mIndex == idx;
      };
      $scope.orgSelected = function () {
        return mIndex > -1;
      };
      $scope.selectOrg = function (idx) {
        mIndex = idx;
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss();
      };
      $scope.confirm = function () {
        $uibModalInstance.close($scope.orgList[mIndex].orgID);
      };

      /*************************************************************************
       * onKeyUp */
      /**
       * Listen for arrow up/down and enter key presses to change and select the
       * selection.
       *
       * @param evt  Keyboard event
       *************************************************************************/
      function onKeyUp(evt) {
        var code = evt.which || evt.keyCode;
        var isUp = code == 38;
        var isDown = code == 40;
        var isEnter = code == 13;

        if (!isUp && !isDown && !isEnter) return;

        if (isUp) mIndex--;
        else if (isDown) mIndex++;
        else if (isEnter) {
          if ($scope.orgSelected()) {
            $scope.confirm();
            return;
          }
        }

        /*---------------------------*/
        /* Adjust the selected index */
        /*---------------------------*/
        if (mIndex >= $scope.orgList.length) mIndex = $scope.orgList.length - 1;

        if (mIndex <= -1 && $scope.orgList.length > 0) mIndex = 0;
        $scope.$digest();
      }

      $window.addEventListener('keyup', onKeyUp);

      /** Prevent key scrolling on the document. */
      var preventDefault = function (event) {
        event.preventDefault();
      };
      $document.on('keydown', preventDefault);

      /*------------------*/
      /* Remove listeners */
      /*------------------*/
      $scope.$on('$destroy', function () {
        $window.removeEventListener('keyup', onKeyUp);
        $document.off('keydown', preventDefault);
      });
    }

    /***************************************************************************
     * show */
    /**
     * Show the modal dialog for selecting an organization from the provided orgList.
     * When an organization is selected, the callback(cb) method will be called
     * with the selected orgID as the parameter.
     *
     * @param orgList  Organization objects to choose from
     * @param cb       Callback function to execute. Will be passed selected orgID
     ***************************************************************************/
    this.show = function (orgList, cb) {
      $uibModal.open(getProps(orgList)).result.then(cb);
    };
  }).name;
